import { useState } from "react";

import {
  EditIcon,
  V2Button,
  V2Dialog,
  V2DialogContent,
  V2DialogHeader,
} from "@stacklet/ui";

import { useAlertContext } from "app/contexts/AlertContext";

import { UpsertUserForm } from "../UpsertUserForm";

import type { UpdateUserInput } from "app/mutations/__generated__/UpdateUserMutation.graphql";

interface Props {
  user: UpdateUserInput;
  iconOnly?: boolean;
}

export function Edit({ user, iconOnly }: Props) {
  const { alertDispatch } = useAlertContext();

  const [isEditDialogOpen, setIsEditDialogOpen] = useState<boolean>(false);

  const [selectedEditUserData, setSelectedEditUserData] =
    useState<UpdateUserInput>({
      name: "",
      email: "",
      roles: [],
      key: 0,
    });

  const onEdited = (message: string) => {
    setIsEditDialogOpen(false);
    setSelectedEditUserData({
      name: "",
      email: "",
      roles: [],
      key: 0,
    });
    alertDispatch({
      message,
      severity: "success",
    });
  };
  const onCancel = () => {
    setIsEditDialogOpen(false);
    setSelectedEditUserData({
      name: "",
      email: "",
      roles: [],
      key: 0,
    });
  };

  return (
    <>
      <V2Button
        aria-label="edit user"
        onPress={() => {
          setIsEditDialogOpen(true);
          setSelectedEditUserData({
            name: user.name,
            email: user.email,
            roles: user.roles,
            key: user.key,
          });
        }}
        variant={iconOnly ? "plain" : "primary"}
      >
        {iconOnly ? <EditIcon /> : "Edit"}
      </V2Button>
      <V2Dialog
        isOpen={isEditDialogOpen}
        onOpenChange={setIsEditDialogOpen}
        size="md"
        isDismissable
      >
        <V2DialogHeader>Edit User</V2DialogHeader>
        <V2DialogContent>
          <UpsertUserForm
            onAdded={onEdited}
            onCancel={onCancel}
            selectedEditUserData={selectedEditUserData}
          />
        </V2DialogContent>
      </V2Dialog>
    </>
  );
}
